import { UserBan } from '../interfaces/interfaces';

export function useBans() {
  const isBannedFromChat = (userbans: UserBan[]) => userbans.filter((b) => b.type === 'CHAT').length > 0;
  const isBannedFromJoin = (userbans: UserBan[]) => userbans.filter((b) => b.type === 'JOIN').length > 0;
  const isBannedFromNameChange = (userbans: UserBan[]) => userbans.filter((b) => b.type === 'NAME_CHANGE').length > 0;
  const isBannedFromRegistration = (userbans: UserBan[]) => userbans.filter((b) => b.type === 'IP_REGISTRATION_BAN').length > 0;
  const isBannedFromMessaging = (userbans: UserBan[]) => userbans.filter((b) => b.type === 'MESSAGING').length > 0;

  return {
    isBannedFromChat,
    isBannedFromJoin,
    isBannedFromNameChange,
    isBannedFromRegistration,
    isBannedFromMessaging,
  };
}
